<template>
  <div>
    <review stage="4" auditType="1" />
  </div>
</template>

<script>
  import review from './review'
  export default {
    name: "history",
    components:{review},
  }
</script>